<template>
	<b-card class="card display-grid bg-white-base h100 w100">
		<div class="card-content display-grid h100 w100">
			<div class="display-flex justify-content-end">
				<b-icon v-if="agendaItem.outputFiles && agendaItem.outputFiles.length" class="icon icon-file margin-right-xxtiny"
					><b-file-icon class="icon-size blue-base"></b-file-icon
				></b-icon>
			</div>
			<div class="display-flex flex-column justify-content-end">
				<span class="day font-size-xxhuge extra-bold">{{ dayFromDate }}</span>
				<span class="until-date semi-bold font-size-big">{{ monthAndYearFromDate }}</span>
				<span class="hour-date font-size-big ink-lighter-1"
					>das {{ agendaItem.startTime }} às {{ agendaItem.endTime }}</span
				>
			</div>
		</div>
		<div
			class="card-footer display-flex justify-content-center align-items-center border-top border-white-darker-4"
			@click="showModal()"
		>
			<span class="font-size-big blue-base font-weight-normal"
				>{{ readOnly ? 'Ver' : 'Ver / Editar' }}
				<b-icon class="icon margin-right-xxtiny"
					><b-chevron-right-icon class="font-size-huge chevron chevron-right"></b-chevron-right-icon
				></b-icon>
			</span>
		</div>
	</b-card>
</template>

<script>
import { BCard, BIcon, BFileIcon, BChevronRightIcon } from '@bossabox-code/design-system';

export default {
	name: 'immersion-agenda-card-item',
	components: {
		BCard,
		BIcon,
		BFileIcon,
		BChevronRightIcon
	},
	props: {
		agendaItem: Object,
		readOnly: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		dayFromDate() {
			return new Date(this.agendaItem.date).getDate();
		},
		monthAndYearFromDate() {
			const formatedDate = new Date(this.agendaItem.date).toLocaleDateString('pt-br', {
				month: 'long',
				year: 'numeric'
			});

			return `de ${formatedDate.charAt(0).toUpperCase() + formatedDate.substr(1)}`;
		}
	},
	methods: {
		showModal() {
			this.$emit('showAgendaCardDetail', this.agendaItem);
		}
	}
};
</script>

<style scoped lang="scss">
.icon-file {
	margin-top: 1rem;
	width: 3rem;
}

.icon-size {
	height: 6rem;
	width: auto;
}

.card {
	width: 21rem;
	height: 21rem;
	grid-template-areas:
		'content'
		'footer';
	grid-template-rows: auto 5.6rem;
	position: relative;

	.card-content {
		grid-area: content;
		grid-template-areas:
			'fileIcon'
			'text';
		grid-template-rows: 2.5rem auto;
		padding: 0 0 2.4rem 2.4rem;

		.day,
		.until-date {
			margin-bottom: 4px;
		}
	}

	.card-footer {
		grid-area: footer;
		cursor: pointer;
	}
}
</style>
